// extracted by mini-css-extract-plugin
module.exports = {"section":"Gallery_section__Kco89","full":"Gallery_full__emRRx","image":"Gallery_image__MI4B1","twoCols":"Gallery_twoCols__5LHkK","threeCols":"Gallery_threeCols__tE6Fr"};